import { useState } from "react"

const STATUS_STYLES = {
  running: { bg:"#dcfce7", color:"#16a34a", label:"Đang chạy" },
  stopped: { bg:"#fee2e2", color:"#dc2626", label:"Dừng"      },
  standby: { bg:"#fef9c3", color:"#92400e", label:"Dự phòng"  },
  ok:      { bg:"#f1f5f9", color:"#64748b", label:"OK"        },
}

// ─── PX Khí — Thiết bị Phân Ly Không Khí (ASU) ───────────

const PXKHI_DATA = [
  // Máy nén khí
  { id:"KH.MN.MN01", name:"Máy nén khí ly tâm chính 1 (6 000 Nm³/h)", type:"Máy nén",     qty:1, since:"06/2017", status:"running", alarm:false },
  { id:"KH.MN.MN02", name:"Máy nén khí ly tâm chính 2 (6 000 Nm³/h)", type:"Máy nén",     qty:1, since:"06/2017", status:"standby", alarm:false },
  { id:"KH.MN.MNB",  name:"Máy nén khí booster tăng áp (N₂ cao áp)",  type:"Máy nén",     qty:1, since:"06/2017", status:"running", alarm:false },
  { id:"KH.MN.LMKK", name:"Làm mát sau máy nén (after-cooler)",       type:"Thiết bị nhiệt",qty:2,since:"06/2017", status:"ok",      alarm:false },
  { id:"KH.MN.LBKK", name:"Lọc bụi & tách ẩm khí vào",               type:"Khác",         qty:2, since:"06/2017", status:"ok",      alarm:false },
  // Làm sạch & sấy khô
  { id:"KH.LS.MST1",  name:"Bình hấp thụ phân tử (Mol Sieve) 1A",     type:"Bình áp lực", qty:1, since:"06/2017", status:"running", alarm:false },
  { id:"KH.LS.MST2",  name:"Bình hấp thụ phân tử (Mol Sieve) 1B",     type:"Bình áp lực", qty:1, since:"06/2017", status:"standby", alarm:false },
  { id:"KH.LS.LSCO2", name:"Thiết bị tách CO₂ trước cột chưng",       type:"Khác",         qty:1, since:"06/2017", status:"ok",      alarm:false },
  { id:"KH.LS.BNLM",  name:"Bộ trao đổi nhiệt chính (PFHE)",          type:"Thiết bị nhiệt",qty:1,since:"06/2017", status:"running", alarm:false },
  // Cột chưng cất
  { id:"KH.CC.CCT",   name:"Cột chưng cất thấp áp (LP column)",       type:"Cột chưng",   qty:1, since:"06/2017", status:"running", alarm:false },
  { id:"KH.CC.CCC",   name:"Cột chưng cất cao áp (HP column)",        type:"Cột chưng",   qty:1, since:"06/2017", status:"running", alarm:false },
  { id:"KH.CC.BNCV",  name:"Bộ ngưng tụ — bay hơi (condenser-vaporizer)", type:"Thiết bị nhiệt",qty:1,since:"06/2017",status:"running",alarm:false },
  { id:"KH.CC.PTAC",  name:"Phân tách argon (crude argon column)",    type:"Cột chưng",   qty:1, since:"09/2018", status:"ok",      alarm:false },
  // Sản phẩm Oxy
  { id:"KH.O2.TO2",   name:"Tua bin giãn nở oxy lỏng",                type:"Máy",          qty:1, since:"06/2017", status:"running", alarm:false },
  { id:"KH.O2.BTO2",  name:"Bơm oxy lỏng LOX",                        type:"Bơm",          qty:2, since:"06/2017", status:"running", alarm:false },
  { id:"KH.O2.HBTO2", name:"Hóa bay oxy lỏng (ambient vaporizer)",    type:"Khác",         qty:2, since:"06/2017", status:"ok",      alarm:false },
  { id:"KH.O2.BLO2",  name:"Bình tích oxy lỏng LOX (40 000 L)",      type:"Bình áp lực", qty:1, since:"06/2017", status:"ok",      alarm:false },
  { id:"KH.O2.DR01",  name:"Đường ống O₂ khí đến xưởng lò cao",      type:"Ống dẫn",     qty:1, since:"06/2017", status:"running", alarm:false },
  { id:"KH.O2.DR02",  name:"Đường ống O₂ khí đến xưởng luyện thép",  type:"Ống dẫn",     qty:1, since:"06/2017", status:"running", alarm:false },
  // Sản phẩm Nitơ
  { id:"KH.N2.BN2G",  name:"Bồn tích N₂ khí cao áp (200 bar)",       type:"Bình áp lực", qty:6, since:"06/2017", status:"ok",      alarm:false },
  { id:"KH.N2.BTN2",  name:"Bồn tích N₂ lỏng LIN (20 000 L)",        type:"Bình áp lực", qty:1, since:"06/2017", status:"ok",      alarm:false },
  { id:"KH.N2.BTN2B", name:"Bơm N₂ lỏng LIN cao áp",                 type:"Bơm",          qty:2, since:"06/2017", status:"standby", alarm:false },
  { id:"KH.N2.HBN2",  name:"Hóa bay N₂ lỏng (ambient vaporizer)",    type:"Khác",         qty:2, since:"06/2017", status:"ok",      alarm:false },
  { id:"KH.N2.DR01",  name:"Đường ống N₂ khí đến xưởng đúc liên tục",type:"Ống dẫn",     qty:1, since:"06/2017", status:"running", alarm:false },
  { id:"KH.N2.DR02",  name:"Đường ống N₂ khí đến xưởng cán thép",    type:"Ống dẫn",     qty:1, since:"06/2017", status:"running", alarm:false },
  { id:"KH.N2.DR03",  name:"Đường ống N₂ khí áp thấp (instrument)",  type:"Ống dẫn",     qty:1, since:"06/2017", status:"running", alarm:false },
  // Hệ thống lạnh & an toàn
  { id:"KH.AT.VANA",  name:"Van an toàn PRV áp suất",                 type:"Van",          qty:8, since:"06/2017", status:"ok",      alarm:false },
  { id:"KH.AT.BDAN",  name:"Bảng điều khiển an toàn DCS",             type:"Điện",         qty:1, since:"06/2017", status:"running", alarm:false },
  { id:"KH.AT.PHAN",  name:"Phân tích O₂/N₂ online (analyzer)",      type:"Điện",         qty:4, since:"06/2017", status:"ok",      alarm:true  },
  { id:"KH.AT.CBKK",  name:"Cảm biến rò rỉ khí O₂/N₂",              type:"Điện",         qty:12,since:"06/2017", status:"ok",      alarm:false },
  // Điện & điều khiển
  { id:"KH.DK.PLCA",  name:"PLC điều khiển ASU (Siemens S7)",         type:"Điện",         qty:1, since:"06/2017", status:"running", alarm:false },
  { id:"KH.DK.HMIA",  name:"HMI vận hành trạm khí",                   type:"Điện",         qty:2, since:"06/2017", status:"ok",      alarm:false },
  { id:"KH.DK.04KV",  name:"Hệ thống điện 0,4kV trạm khí",           type:"Điện",         qty:1, since:"06/2017", status:"ok",      alarm:false },
  { id:"KH.DK.SCADA", name:"Hệ thống SCADA trạm khí",                 type:"Điện",         qty:1, since:"06/2017", status:"running", alarm:false },
]

// ─── Tháp Phân Lưu ───────────────────────────────────────

// ── Instrument live values (from SCADA) ──
const TPL_INSTRUMENTS = {
  PICAS_101: { val:"0.003", unit:"MPa",  label:"Áp suất không khí vào",  color:"#2563eb" },
  FTC_106:   { val:"0",     unit:"m³/h", label:"Lưu lượng N₂ (FTC 106)", color:"#2563eb" },
  FRQ_101:   { val:"0",     unit:"m³/h", label:"Lưu lượng O₂ (FRQ 101)", color:"#ef4444" },
  ARA_104:   { val:"0",     unit:"ppm",  label:"ARA 104 (tạp chất)",     color:"#f59e0b" },
  ARA_102:   { val:"97.00", unit:"%",    label:"Độ sạch O₂ (ARA 102)",   color:"#ef4444" },
  TI_101:    { val:"14.4",  unit:"°C",   label:"TI 101 — T° vào",        color:"#f59e0b" },
  PIC_107:   { val:"0.0",   unit:"kPa",  label:"PIC 107",                color:"#64748b" },
  TI_104:    { val:"14.3",  unit:"°C",   label:"TI 104",                 color:"#f59e0b" },
  TI_103:    { val:"11.9",  unit:"°C",   label:"TI 103 (E1 ra)",         color:"#f59e0b" },
  TI_102:    { val:"3.9",   unit:"°C",   label:"TI 102 (E2 ra)",         color:"#f59e0b" },
  PI_108:    { val:"0.3",   unit:"kPa",  label:"PI 108",                 color:"#94a3b8" },
  TI_443:    { val:"-95.0", unit:"°C",   label:"TI 443 (E3)",            color:"#0ea5e9" },
  TI_441:    { val:"OC",    unit:"",     label:"TI 441",                 color:"#94a3b8" },
  TI_442:    { val:"-73.0", unit:"°C",   label:"TI 442 (E2 lạnh)",       color:"#0ea5e9" },
  LI_2:      { val:"3527",  unit:"mm",   label:"LI 2 — Mức lỏng C2",    color:"#22c55e" },
  LIC_1:     { val:"408",   unit:"mm",   label:"LIC 1 — Mức lỏng C1",   color:"#22c55e" },
  PI_1:      { val:"0.009", unit:"MPa",  label:"PI 1 — Áp suất C1",     color:"#94a3b8" },
  PDI_1:     { val:"0.2",   unit:"kPa",  label:"PDI 1 — ΔP C1",         color:"#64748b" },
  PI_2:      { val:"4",     unit:"kPa",  label:"PI 2 — Áp suất C2",     color:"#94a3b8" },
  PDI_2:     { val:"3.1",   unit:"kPa",  label:"PDI 2 — ΔP C2",         color:"#64748b" },
  PI_3:      { val:"3.1",   unit:"kPa",  label:"PI 3",                  color:"#94a3b8" },
  PI_4:      { val:"0.00",  unit:"kPa",  label:"PI 4",                  color:"#94a3b8" },
  TI_3:      { val:"-186.0",unit:"°C",   label:"TI 3 (đỉnh C2)",        color:"#0ea5e9" },
  TI_2:      { val:"-180.3",unit:"°C",   label:"TI 2",                  color:"#0ea5e9" },
  TI_1:      { val:"-176.8",unit:"°C",   label:"TI 1 (đáy C2)",         color:"#0ea5e9" },
  TI_100A:   { val:"-5.9",  unit:"°C",   label:"TI 100A",               color:"#f59e0b" },
  TI_100B:   { val:"10.1",  unit:"°C",   label:"TI 100B",               color:"#f59e0b" },
  TI_100C:   { val:"14.6",  unit:"°C",   label:"TI 100C",               color:"#f59e0b" },
  STEP:      { val:"08",    unit:"",     label:"Bước hiện tại",          color:"#7c3aed" },
}

// ── Hourly log data (Nhật ký vận hành) ──
const TPL_LOG = [
  { gio:23, ca:10, n2:551755,  ftc106:7993, o2:521883, frq101:3619, ara104:85, ara102:99.99, ti101:19.1, pic107:18.1, ti104:16.4, ti443:-59,  ti441:6,   pic106:2.9, ti103:11.3, ti442:null,  pi108:5,   ti102:9,   pi2:62, ti4:11.3, li2:null, pi3:16.5, pdi2:9,  pdi1:null, lic1:4,   ti3:null,  ti2:null,  ti1:null,  ti100a:null, ti100b:18.4, ti100c:null  },
  { gio:0,  ca:10, n2:560101,  ftc106:7831, o2:523381, frq101:3683, ara104:5,  ara102:4,    ti101:16,   pic107:11,   ti104:13,   ti443:-56,  ti441:4,   pic106:12,  ti103:80,   ti442:81,    pi108:13,  ti102:160, pi2:4,  ti4:4,    li2:4,    pi3:4,    pdi2:4,  pdi1:9,    lic1:4,   ti3:605,   ti2:5,     ti1:5,     ti100a:7,    ti100b:null, ti100c:null  },
  { gio:1,  ca:4,  n2:546521,  ftc106:7750, o2:531333, frq101:3653, ara104:5,  ara102:4,    ti101:14,   pic107:54,   ti104:13,   ti443:null, ti441:4,   pic106:4,   ti103:null, ti442:447,   pi108:4,   ti102:4,   pi2:4,  ti4:4,    li2:4,    pi3:4,    pdi2:4,  pdi1:4,    lic1:4,   ti3:4,     ti2:4,     ti1:4,     ti100a:null, ti100b:null, ti100c:null  },
  { gio:2,  ca:6,  n2:553143,  ftc106:7795, o2:524119, frq101:4,    ara104:11, ara102:5,    ti101:18,   pic107:6,    ti104:4,    ti443:-56,  ti441:58,  pic106:4,   ti103:17,   ti442:null,  pi108:31,  ti102:14,  pi2:11, ti4:11,   li2:4,    pi3:4,    pdi2:4,  pdi1:4,    lic1:4,   ti3:4,     ti2:4,     ti1:4,     ti100a:null, ti100b:null, ti100c:null  },
  { gio:4,  ca:10, n2:863539,  ftc106:7729, o2:529887, frq101:3555, ara104:11, ara102:11,   ti101:17.6, pic107:16.2, ti104:15.8, ti443:60.7, ti441:63.4,pic106:16.7,ti103:14.3, ti442:58.9,  pi108:30.2,ti102:15.5,pi2:29, ti4:36.2, li2:0.18, pi3:45.9, pdi2:11.8,pdi1:null, lic1:null,ti3:null,  ti2:null,  ti1:null,  ti100a:550,  ti100b:11,   ti100c:null  },
  { gio:5,  ca:11, n2:876030,  ftc106:7511, o2:525259, frq101:3572, ara104:11, ara102:11,   ti101:15.9, pic107:16.9, ti104:12.4, ti443:58.7, ti441:61.6,pic106:10.5,ti103:12.6, ti442:56.8,  pi108:11,  ti102:11.7,pi2:null,ti4:null, li2:null, pi3:null, pdi2:null,pdi1:null, lic1:null,ti3:null,  ti2:null,  ti1:515,   ti100a:null, ti100b:11,   ti100c:null  },
  { gio:6,  ca:8,  n2:583599,  ftc106:7666, o2:556319, frq101:3559, ara104:11, ara102:11,   ti101:15.6, pic107:14.9, ti104:11.7, ti443:61.5, ti441:63.2,pic106:10,  ti103:12.6, ti442:61.4,  pi108:28.3,ti102:11, pi2:4,  ti4:11,   li2:33.40,pi3:11.5, pdi2:null,pdi1:null, lic1:null,ti3:null,  ti2:null,  ti1:615,   ti100a:6,    ti100b:null, ti100c:null  },
  { gio:7,  ca:108,n2:920773,  ftc106:7572, o2:526054, frq101:3542, ara104:89, ara102:4,    ti101:15,   pic107:15.3, ti104:11,   ti443:64.5, ti441:64.7,pic106:9.9, ti103:12.2, ti442:64.5,  pi108:28.4,ti102:12.9,pi2:29.75,ti4:23,li2:0.23, pi3:0.2,  pdi2:42, pdi1:1.81, lic1:null,ti3:0.80,  ti2:null,  ti1:626,   ti100a:1.9,  ti100b:0,    ti100c:null  },
  { gio:8,  ca:11, n2:993455,  ftc106:7897, o2:526374, frq101:3599, ara104:87, ara102:4,    ti101:13.5, pic107:18,   ti104:14.3, ti443:57,   ti441:60.3,pic106:11,  ti103:14,   ti442:53.3,  pi108:31.2,ti102:15.6,pi2:29.2,ti4:35.25,li2:4.7, pi3:47.4, pdi2:18.8,pdi1:0.5,  lic1:0.455,ti3:null,  ti2:null,  ti1:680,   ti100a:1.8,  ti100b:0,    ti100c:null  },
]

function ThapPhanLuuView() {
  const [selInstr, setSelInstr] = useState(null)
  const [hovId,    setHovId]    = useState(null)
  const [logPage,  setLogPage]  = useState(0)  // not used yet

  const instr = TPL_INSTRUMENTS

  // canonical helpers
  const HPipe = ({color="#22c55e",active=true,width=24}) => (
    <div style={{height:3,width,flexShrink:0,background:active?color:"#e2e8f0",
      borderRadius:2,boxShadow:active?`0 0 4px ${color}66`:"none"}}/>
  )
  const Arrow = ({color="#22c55e",active=true,dir="right"}) => (
    <span style={{fontSize:10,color:active?color:"#e2e8f0",flexShrink:0,lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"}}>
      {dir==="right"?"▶":dir==="down"?"▼":dir==="up"?"▲":"◀"}</span>
  )

  // ── Instrument value card ──
  const InstrCard = ({id, small=false}) => {
    const p = instr[id]
    if (!p) return null
    const isSel = selInstr===id
    const alarm = id==="ARA_104"&&parseFloat(p.val)>100
    return (
      <div onClick={()=>setSelInstr(isSel?null:id)}
        style={{
          background:isSel?"#eff6ff":alarm?"#fef2f2":"white",
          border:`1px solid ${isSel?"#2563eb":alarm?"#fca5a5":"#e2e8f0"}`,
          borderRadius:6,padding:small?"3px 6px":"5px 8px",cursor:"pointer",
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.12)":"0 1px 2px rgba(0,0,0,0.04)",
          transition:"all .15s",textAlign:"center",flexShrink:0
        }}>
        <div style={{fontSize:7,color:"#94a3b8",whiteSpace:"nowrap",letterSpacing:0.5}}>{id.replace("_","_")}</div>
        <div style={{
          fontSize:small?11:13,fontWeight:900,fontFamily:"monospace",lineHeight:1,
          color:alarm?"#ef4444":p.color
        }}>{p.val}</div>
        {p.unit&&<div style={{fontSize:6,color:"#94a3b8"}}>{p.unit}</div>}
      </div>
    )
  }

  // ── Column SVG (detailed) ──
  const DetailColumn = ({id, label, levelMM, levelMax, pres, dp, tempTop, tempMid, tempBot, w=64, h=220, color="#2563eb"}) => {
    const fillFrac = Math.min(Math.max(levelMM/levelMax,0),1)
    const fillY    = h*0.08 + (h*0.82)*(1-fillFrac)
    const cx       = w/2
    return (
      <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block"}}>
        {/* Column body */}
        <path d={`M ${cx-20},12 Q ${cx},4 ${cx+20},12 L ${cx+20},${h-20} Q ${cx},${h-12} ${cx-20},${h-20} Z`}
          fill="white" stroke={color} strokeWidth={1.5}/>
        {/* Packing / trays pattern */}
        {Array.from({length:8},(_,i)=>(
          <line key={i} x1={cx-18} y1={12+(h-32)*(i+1)/9} x2={cx+18} y2={12+(h-32)*(i+1)/9}
            stroke={color} strokeWidth={0.6} opacity={0.3}/>
        ))}
        {/* Liquid fill */}
        <clipPath id={`colclip${id}`}>
          <path d={`M ${cx-19},13 L ${cx+19},13 L ${cx+19},${h-21} Q ${cx},${h-13} ${cx-19},${h-21} Z`}/>
        </clipPath>
        <rect x={cx-19} y={fillY} width={38} height={h-21-fillY}
          fill={color} opacity={0.15} clipPath={`url(#colclip${id})`}/>
        {/* Level indicator line */}
        {levelMM>0&&<line x1={cx-20} y1={fillY} x2={cx+20} y2={fillY}
          stroke={color} strokeWidth={1.5} strokeDasharray="4 2"/>}
        {/* Label */}
        <text x={cx} y={h/2+4} textAnchor="middle" fontSize={11} fontWeight="900" fill={color}>{label}</text>
        {/* Level mm */}
        {levelMM>0&&<text x={cx} y={h/2+16} textAnchor="middle" fontSize={8}
          fill="#64748b" fontFamily="monospace">{levelMM}mm</text>}
        {/* Top inlet */}
        <rect x={cx-2} y={0} width={4} height={14} fill={color} rx={1} opacity={0.8}/>
        {/* Bottom outlet */}
        <rect x={cx-2} y={h-14} width={4} height={14} fill={color} rx={1} opacity={0.8}/>
        {/* Side outlets */}
        <rect x={0} y={h*0.35} width={12} height={4} fill={color} opacity={0.7} rx={1}/>
        <rect x={w-12} y={h*0.35} width={12} height={4} fill={color} opacity={0.7} rx={1}/>
        {/* Temp markers */}
        {tempTop&&<text x={cx} y={22} textAnchor="middle" fontSize={7} fill={color} fontFamily="monospace">{tempTop}°</text>}
        {tempMid&&<text x={cx} y={h/2-8} textAnchor="middle" fontSize={7} fill={color} fontFamily="monospace">{tempMid}°</text>}
        {tempBot&&<text x={cx} y={h-24} textAnchor="middle" fontSize={7} fill={color} fontFamily="monospace">{tempBot}°</text>}
      </svg>
    )
  }

  // ── Heat exchanger SVG ──
  const HeatExSVG = ({label, tempIn, tempOut, w=48, h=52, color="#64748b"}) => (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block"}}>
      <rect x={2} y={8} width={w-4} height={h-16} rx={4}
        fill="white" stroke={color} strokeWidth={1.5}/>
      {Array.from({length:4},(_,i)=>(
        <line key={i} x1={4} y1={12+i*7} x2={w-4} y2={12+i*7}
          stroke={color} strokeWidth={0.7} opacity={0.3}/>
      ))}
      <text x={w/2} y={h/2+3} textAnchor="middle" fontSize={9} fontWeight="800" fill={color}>{label}</text>
      {tempIn&&<text x={4} y={7} fontSize={6} fill="#f59e0b" fontWeight="600">{tempIn}°</text>}
      {tempOut&&<text x={w-4} y={7} textAnchor="end" fontSize={6} fill="#0ea5e9" fontWeight="600">{tempOut}°</text>}
    </svg>
  )

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>

        {/* KPI strip */}
        <div style={{display:"flex",gap:8,marginBottom:12,flexWrap:"wrap"}}>
          {[
            {label:"Áp suất vào",    value:`${instr.PICAS_101.val} MPa`, icon:"💨", color:"#2563eb"},
            {label:"Lưu lượng N₂",   value:`${instr.FTC_106.val} m³/h`, icon:"🔵", color:"#2563eb"},
            {label:"Lưu lượng O₂",   value:`${instr.FRQ_101.val} m³/h`, icon:"🔴", color:"#ef4444"},
            {label:"Độ sạch O₂",     value:`${instr.ARA_102.val}%`,     icon:"🔬", color:"#ef4444"},
            {label:"T° Cold box",    value:`${instr.TI_1.val}°C`,       icon:"❄",  color:"#0ea5e9"},
            {label:"Bước hiện tại",  value:`Bước ${instr.STEP.val}`,    icon:"⚙",  color:"#7c3aed"},
          ].map(k=>(
            <div key={k.label} style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"7px 10px",display:"flex",alignItems:"center",gap:7,
              flex:1,minWidth:90,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <span style={{fontSize:16}}>{k.icon}</span>
              <div>
                <div style={{fontSize:13,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:8,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* ── Synoptic process diagram ── */}
        <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
          padding:"14px 16px",marginBottom:10,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
          <div style={{fontSize:11,fontWeight:700,color:"#64748b",
            letterSpacing:1,textTransform:"uppercase",marginBottom:12}}>
            Sơ đồ vận hành tháp phân lưu
          </div>

          <div style={{display:"flex",gap:12,alignItems:"flex-start",overflowX:"auto"}}>

            {/* ── LEFT: Air inlet + instruments ── */}
            <div style={{display:"flex",flexDirection:"column",gap:8,flexShrink:0,width:120}}>
              <div style={{fontSize:9,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>Đầu vào</div>
              <InstrCard id="PICAS_101"/>
              <InstrCard id="TI_101"/>
              <InstrCard id="ARA_104"/>
              {/* Air flow arrows */}
              <div style={{display:"flex",alignItems:"center",gap:4,padding:"4px 0"}}>
                <HPipe color="#64748b" active={true} width={20}/>
                <Arrow color="#64748b" active={true} dir="right"/>
                <div style={{fontSize:8,color:"#64748b",fontWeight:600,whiteSpace:"nowrap"}}>Sạc KK</div>
              </div>
              <div style={{display:"flex",alignItems:"center",gap:4}}>
                <HPipe color="#2563eb" active={true} width={20}/>
                <Arrow color="#2563eb" active={true} dir="right"/>
                <div style={{fontSize:8,color:"#2563eb",fontWeight:600,whiteSpace:"nowrap"}}>Từ thanh lọc</div>
              </div>
              <div style={{marginTop:4}}>
                <InstrCard id="FTC_106"/>
              </div>
            </div>

            {/* ── CENTER-LEFT: Heat exchangers E1/E2/E3 ── */}
            <div style={{display:"flex",flexDirection:"column",gap:6,flexShrink:0,width:140}}>
              <div style={{fontSize:9,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>Trao đổi nhiệt</div>
              {/* E3 */}
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <HeatExSVG label="E3" tempIn={instr.TI_104.val} tempOut={instr.TI_443.val} w={44} h={48} color="#64748b"/>
                <div style={{display:"flex",flexDirection:"column",gap:3}}>
                  <InstrCard id="TI_104" small/>
                  <InstrCard id="TI_443" small/>
                  <InstrCard id="PIC_107" small/>
                </div>
              </div>
              {/* E1 */}
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <HeatExSVG label="E1" tempIn={instr.TI_103.val} tempOut={instr.TI_441.val} w={44} h={48} color="#2563eb"/>
                <div style={{display:"flex",flexDirection:"column",gap:3}}>
                  <InstrCard id="TI_103" small/>
                  <InstrCard id="TI_441" small/>
                </div>
              </div>
              {/* E2 */}
              <div style={{display:"flex",alignItems:"center",gap:6}}>
                <HeatExSVG label="E2" tempIn={instr.TI_102.val} tempOut={instr.TI_442.val} w={44} h={48} color="#0ea5e9"/>
                <div style={{display:"flex",flexDirection:"column",gap:3}}>
                  <InstrCard id="TI_102" small/>
                  <InstrCard id="TI_442" small/>
                  <InstrCard id="PI_108" small/>
                </div>
              </div>
            </div>

            {/* ── CENTER: connecting flow + E4 ── */}
            <div style={{display:"flex",flexDirection:"column",gap:6,alignItems:"center",flexShrink:0,width:80}}>
              <div style={{fontSize:9,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>E4</div>
              <HeatExSVG label="E4" w={56} h={60} color="#94a3b8"/>
              <div style={{display:"flex",alignItems:"center",gap:3}}>
                <Arrow color="#ef4444" active={true} dir="down"/>
                <HPipe color="#ef4444" active={true} width={20}/>
              </div>
              <InstrCard id="FRQ_101"/>
              <InstrCard id="ARA_102"/>
              <div style={{marginTop:4}}>
                <Arrow color="#2563eb" active={true} dir="up"/>
              </div>
            </div>

            {/* ── RIGHT: Distillation columns C1 & C2 ── */}
            <div style={{display:"flex",gap:10,flexShrink:0,alignItems:"flex-start"}}>
              {/* C2 (high pressure) */}
              <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
                <div style={{fontSize:8,fontWeight:700,color:"#2563eb",letterSpacing:1}}>THÁP C2 (HP)</div>
                <DetailColumn id="C2" label="C2" levelMM={parseInt(instr.LI_2.val)}
                  levelMax={5000} pres={4} dp={3.1}
                  tempTop={instr.TI_3.val} tempMid={instr.TI_2.val} tempBot={instr.TI_1.val}
                  w={64} h={200} color="#2563eb"/>
                <div style={{display:"flex",gap:4,flexWrap:"wrap",width:64}}>
                  <InstrCard id="LI_2" small/>
                  <InstrCard id="PI_2" small/>
                  <InstrCard id="PDI_2" small/>
                </div>
              </div>
              {/* C1 (low pressure) */}
              <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:4}}>
                <div style={{fontSize:8,fontWeight:700,color:"#ef4444",letterSpacing:1}}>THÁP C1 (LP)</div>
                <DetailColumn id="C1" label="C1" levelMM={parseInt(instr.LIC_1.val)}
                  levelMax={1000} pres={0.009}
                  tempTop={instr.TI_3.val} tempMid={instr.TI_2.val} tempBot={instr.TI_1.val}
                  w={64} h={200} color="#ef4444"/>
                <div style={{display:"flex",gap:4,flexWrap:"wrap",width:64}}>
                  <InstrCard id="LIC_1" small/>
                  <InstrCard id="PI_1" small/>
                  <InstrCard id="PDI_1" small/>
                </div>
              </div>
              {/* Right instruments */}
              <div style={{display:"flex",flexDirection:"column",gap:6,width:80}}>
                <div style={{fontSize:8,fontWeight:700,color:"#64748b",letterSpacing:1}}>Đầu ra</div>
                <InstrCard id="PI_4"/>
                <InstrCard id="PI_3"/>
                <InstrCard id="TI_3"/>
                <InstrCard id="TI_2"/>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <HPipe color="#2563eb" active={true} width={16}/>
                  <Arrow color="#2563eb" active={true} dir="right"/>
                  <span style={{fontSize:7,fontWeight:700,color:"#2563eb"}}>N₂</span>
                </div>
                <div style={{display:"flex",alignItems:"center",gap:4}}>
                  <HPipe color="#ef4444" active={true} width={16}/>
                  <Arrow color="#ef4444" active={true} dir="right"/>
                  <span style={{fontSize:7,fontWeight:700,color:"#ef4444"}}>O₂</span>
                </div>
                <InstrCard id="TI_100A" small/>
                <InstrCard id="TI_100B" small/>
                <InstrCard id="TI_100C" small/>
              </div>
            </div>

          </div>
        </div>

        {/* ── Nhật Ký Vận Hành Tháp Phân Lưu ── */}
        <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
          padding:"12px 16px",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
          <div style={{
            display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:10
          }}>
            <div>
              <div style={{fontSize:12,fontWeight:700,color:"#1e3a5f",letterSpacing:0.5}}>
                Nhật Ký Vận Hành Tháp Phân Lưu
              </div>
              <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>
                HM.C0.1 · Ngày 06 · Tháng 01
              </div>
            </div>
            <div style={{display:"flex",gap:6,alignItems:"center"}}>
              <span style={{fontSize:9,color:"#94a3b8"}}>Vận hành ca 3: Lương Văn Hiển</span>
            </div>
          </div>

          <div style={{overflowX:"auto"}}>
            <table style={{borderCollapse:"collapse",fontSize:9,minWidth:1100}}>
              <thead>
                <tr>
                  <th colSpan={5} style={{padding:"4px 8px",border:"1px solid #e2e8f0",
                    background:"#eff6ff",fontSize:9,fontWeight:700,color:"#1e3a5f",textAlign:"center"}}>
                    Sản lượng
                  </th>
                  <th colSpan={3} style={{padding:"4px 8px",border:"1px solid #e2e8f0",
                    background:"#fee2e2",fontSize:9,fontWeight:700,color:"#991b1b",textAlign:"center"}}>
                    Phân tích khí
                  </th>
                  <th colSpan={6} style={{padding:"4px 8px",border:"1px solid #e2e8f0",
                    background:"#fef9c3",fontSize:9,fontWeight:700,color:"#92400e",textAlign:"center"}}>
                    Nhiệt độ (°C)
                  </th>
                  <th colSpan={4} style={{padding:"4px 8px",border:"1px solid #e2e8f0",
                    background:"#f0fdf4",fontSize:9,fontWeight:700,color:"#166534",textAlign:"center"}}>
                    Áp suất (kPa)
                  </th>
                  <th colSpan={4} style={{padding:"4px 8px",border:"1px solid #e2e8f0",
                    background:"#f5f3ff",fontSize:9,fontWeight:700,color:"#5b21b6",textAlign:"center"}}>
                    Mức lỏng & ΔP
                  </th>
                  <th colSpan={3} style={{padding:"4px 8px",border:"1px solid #e2e8f0",
                    background:"#fef2f2",fontSize:9,fontWeight:700,color:"#991b1b",textAlign:"center"}}>
                    T° Cold box
                  </th>
                </tr>
                <tr style={{background:"#f8fafc",borderBottom:"2px solid #e2e8f0"}}>
                  {[
                    {h:"Giờ",    c:"#374151"},
                    {h:"Ca",     c:"#374151"},
                    {h:"N₂ (m³)",c:"#2563eb"},
                    {h:"FTC106",c:"#2563eb"},
                    {h:"O₂ (m³)",c:"#ef4444"},
                    {h:"FRQ101",c:"#ef4444"},
                    {h:"ARA104\n(ppm)",c:"#f59e0b"},
                    {h:"ARA102\n(%)",  c:"#ef4444"},
                    {h:"TI101",c:"#f59e0b"},{h:"PIC107",c:"#64748b"},
                    {h:"TI104",c:"#f59e0b"},{h:"TI443",c:"#0ea5e9"},
                    {h:"TI103",c:"#f59e0b"},{h:"TI442",c:"#0ea5e9"},
                    {h:"PI108", c:"#94a3b8"},{h:"PI2",   c:"#94a3b8"},
                    {h:"PIC106",c:"#94a3b8"},{h:"PI1",   c:"#94a3b8"},
                    {h:"LI2\n(mm)",c:"#22c55e"},{h:"LIC1\n(mm)",c:"#22c55e"},
                    {h:"PDI2",c:"#64748b"},{h:"PDI1",c:"#64748b"},
                    {h:"TI100A",c:"#f59e0b"},{h:"TI100B",c:"#f59e0b"},{h:"TI100C",c:"#f59e0b"},
                  ].map(col=>(
                    <th key={col.h} style={{
                      padding:"4px 6px",border:"1px solid #e2e8f0",
                      fontSize:8,fontWeight:700,color:col.c,
                      whiteSpace:"pre",textAlign:"center"
                    }}>{col.h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {TPL_LOG.map((row,ri)=>(
                  <tr key={row.gio}
                    style={{background:ri%2===0?"white":"#fafafa",borderBottom:"1px solid #f1f5f9"}}
                    onMouseEnter={e=>e.currentTarget.style.background="#eff6ff"}
                    onMouseLeave={e=>e.currentTarget.style.background=ri%2===0?"white":"#fafafa"}>
                    {/* Giờ */}
                    <td style={{padding:"5px 6px",border:"1px solid #f1f5f9",
                      textAlign:"center",fontWeight:700,color:"#374151",fontFamily:"monospace"}}>{row.gio}h</td>
                    {/* Ca */}
                    <td style={{padding:"5px 6px",border:"1px solid #f1f5f9",
                      textAlign:"center",color:"#2563eb",fontWeight:600}}>{row.ca}</td>
                    {/* N2 */}
                    <td style={{padding:"5px 6px",border:"1px solid #f1f5f9",
                      textAlign:"right",fontFamily:"monospace",color:"#2563eb",fontWeight:700}}>{row.n2?.toLocaleString()??<span style={{color:"#e2e8f0"}}>—</span>}</td>
                    {/* FTC106 */}
                    <td style={{padding:"5px 6px",border:"1px solid #f1f5f9",
                      textAlign:"right",fontFamily:"monospace",color:"#2563eb"}}>{row.ftc106??<span style={{color:"#e2e8f0"}}>—</span>}</td>
                    {/* O2 */}
                    <td style={{padding:"5px 6px",border:"1px solid #f1f5f9",
                      textAlign:"right",fontFamily:"monospace",color:"#ef4444",fontWeight:700}}>{row.o2?.toLocaleString()??<span style={{color:"#e2e8f0"}}>—</span>}</td>
                    {/* FRQ101 */}
                    <td style={{padding:"5px 6px",border:"1px solid #f1f5f9",
                      textAlign:"right",fontFamily:"monospace",color:"#ef4444"}}>{row.frq101??<span style={{color:"#e2e8f0"}}>—</span>}</td>
                    {/* ARA104 */}
                    <td style={{padding:"5px 6px",border:"1px solid #f1f5f9",
                      textAlign:"right",fontFamily:"monospace",
                      color:row.ara104>100?"#ef4444":"#f59e0b",
                      fontWeight:row.ara104>100?700:400}}>{row.ara104??<span style={{color:"#e2e8f0"}}>—</span>}</td>
                    {/* ARA102 */}
                    <td style={{padding:"5px 6px",border:"1px solid #f1f5f9",
                      textAlign:"right",fontFamily:"monospace",color:"#ef4444",fontWeight:700}}>{row.ara102??<span style={{color:"#e2e8f0"}}>—</span>}</td>
                    {/* Temperatures */}
                    {[row.ti101,row.pic107,row.ti104,row.ti443,row.ti103,row.ti442].map((v,i)=>(
                      <td key={i} style={{padding:"5px 6px",border:"1px solid #f1f5f9",
                        textAlign:"right",fontFamily:"monospace",
                        color:v==null?"#e2e8f0":v<0?"#0ea5e9":"#f59e0b"}}>{v??<span>—</span>}</td>
                    ))}
                    {/* Pressures */}
                    {[row.pi108,row.pi2,row.pic106,null].map((v,i)=>(
                      <td key={i} style={{padding:"5px 6px",border:"1px solid #f1f5f9",
                        textAlign:"right",fontFamily:"monospace",color:v==null?"#e2e8f0":"#94a3b8"}}>{v??<span>—</span>}</td>
                    ))}
                    {/* Levels & ΔP */}
                    {[row.li2,row.lic1,row.pdi2,row.pdi1].map((v,i)=>(
                      <td key={i} style={{padding:"5px 6px",border:"1px solid #f1f5f9",
                        textAlign:"right",fontFamily:"monospace",
                        color:v==null?"#e2e8f0":i<2?"#22c55e":"#64748b"}}>{v??<span>—</span>}</td>
                    ))}
                    {/* Cold box temps */}
                    {[row.ti100a,row.ti100b,row.ti100c].map((v,i)=>(
                      <td key={i} style={{padding:"5px 6px",border:"1px solid #f1f5f9",
                        textAlign:"right",fontFamily:"monospace",color:v==null?"#e2e8f0":"#f59e0b"}}>{v??<span>—</span>}</td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

      </div>

      {/* Detail panel */}
      <div style={{width:268,background:"white",borderLeft:"1px solid #e2e8f0",
        flexShrink:0,overflowY:"auto",display:"flex",flexDirection:"column"}}>
        {!selInstr ? (
          <div style={{flex:1,display:"flex",flexDirection:"column",alignItems:"center",
            justifyContent:"center",color:"#94a3b8",padding:20,textAlign:"center",gap:8}}>
            <span style={{fontSize:32}}>🔬</span>
            <span style={{fontWeight:600,color:"#64748b",fontSize:12}}>Chọn thiết bị đo</span>
            <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>
              Nhấp vào thẻ instrument trên sơ đồ
            </span>
          </div>
        ) : (()=>{
          const p = instr[selInstr]
          const trend = Array.from({length:18},(_,i)=>
            30+Math.abs(Math.sin(i/3))*50+(Math.random()-.5)*8
          )
          return (
            <div>
              <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
                display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                <div>
                  <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{selInstr} · </span>
                  <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{p.label}</span>
                </div>
                <button onClick={()=>setSelInstr(null)}
                  style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>×</button>
              </div>
              <div style={{padding:"16px",background:"white",borderBottom:"1px solid #f1f5f9",textAlign:"center"}}>
                <div style={{fontSize:32,fontWeight:900,fontFamily:"monospace",color:p.color,lineHeight:1}}>
                  {p.val}
                </div>
                <div style={{fontSize:11,color:"#94a3b8",marginTop:4}}>{p.unit}</div>
              </div>
              {[["ID",selInstr],["Giá trị",`${p.val} ${p.unit}`],["Mô tả",p.label]].map(([k,v])=>(
                <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
                  <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
                  <span style={{fontSize:11,fontWeight:600,color:"#0f172a"}}>{v}</span>
                </div>
              ))}
              <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>24H QUA</div>
              <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
                <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
                  {trend.map((v,i)=>(
                    <div key={i} style={{flex:1,height:`${v}%`,background:p.color,borderRadius:"1px 1px 0 0",opacity:0.8}}/>
                  ))}
                </div>
                <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
                  <span style={{fontSize:7,color:"#94a3b8"}}>-24h</span>
                  <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
                </div>
              </div>
            </div>
          )
        })()}
      </div>
    </div>
  )
}


// ─── Vận Hành Trạm Khí ────────────────────────────────────

// Production params
const ASU_PARAMS = {
  airFlow:     { val:5840, set:6000, unit:"Nm³/h", label:"Lưu lượng không khí vào", color:"#2563eb" },
  o2Purity:    { val:99.6, set:99.5, unit:"%",     label:"Độ tinh khiết O₂",        color:"#ef4444" },
  n2Purity:    { val:99.999,set:99.999,unit:"%",   label:"Độ tinh khiết N₂",        color:"#2563eb" },
  o2Flow:      { val:1240, set:1200, unit:"Nm³/h", label:"Lưu lượng O₂ ra",         color:"#ef4444" },
  n2FlowHP:    { val:860,  set:900,  unit:"Nm³/h", label:"N₂ cao áp ra",            color:"#2563eb" },
  n2FlowLP:    { val:320,  set:300,  unit:"Nm³/h", label:"N₂ thấp áp ra",           color:"#0ea5e9" },
  hpColPres:   { val:5.8,  set:5.8,  unit:"bar",   label:"Áp suất cột HP",          color:"#94a3b8" },
  lpColPres:   { val:1.35, set:1.35, unit:"bar",   label:"Áp suất cột LP",          color:"#94a3b8" },
  coldboxTemp: { val:-175, set:-176, unit:"°C",    label:"Nhiệt độ cold box",       color:"#0ea5e9" },
  o2TankLevel: { val:68,   set:null, unit:"%",     label:"Mức LOX bồn chứa",        color:"#ef4444" },
  n2TankLevel: { val:45,   set:null, unit:"%",     label:"Mức LIN bồn chứa",        color:"#2563eb" },
  power:       { val:1840, set:null, unit:"kW",    label:"Công suất tiêu thụ",      color:"#f59e0b" },
}

const ASU_OUTPUTS = [
  { id:"O2-LC",  label:"O₂ → Lò cao",        flow:450,  unit:"Nm³/h", purity:99.6, pres:18, color:"#ef4444", active:true  },
  { id:"O2-LT",  label:"O₂ → Luyện thép",    flow:790,  unit:"Nm³/h", purity:99.6, pres:16, color:"#ef4444", active:true  },
  { id:"N2-HP",  label:"N₂ cao áp → Đúc",    flow:860,  unit:"Nm³/h", purity:99.999,pres:200,color:"#2563eb",active:true  },
  { id:"N2-LP",  label:"N₂ thấp áp → Cán",   flow:320,  unit:"Nm³/h", purity:99.9, pres:6,  color:"#0ea5e9", active:true  },
  { id:"N2-INS", label:"N₂ instrument",       flow:85,   unit:"Nm³/h", purity:99.9, pres:6,  color:"#94a3b8", active:true  },
]

// Tank SVG
function TankSVG({ level=68, label="LOX", color="#ef4444", w=60, h=100 }) {
  const cx = w/2
  const fillH = ((level/100)*(h-28))
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block"}}>
      {/* Tank body */}
      <rect x={8} y={8} width={w-16} height={h-24} rx={5}
        fill="white" stroke={color} strokeWidth={1.5}/>
      {/* Fill */}
      <clipPath id={`tankclip-${label}`}>
        <rect x={9} y={9} width={w-18} height={h-26}/>
      </clipPath>
      <rect x={9} y={9+(h-26-fillH)} width={w-18} height={fillH}
        fill={color} opacity={0.2} clipPath={`url(#tankclip-${label})`}/>
      {/* Level line */}
      <line x1={8} y1={9+(h-26-fillH)} x2={w-8} y2={9+(h-26-fillH)}
        stroke={color} strokeWidth={1} strokeDasharray="3 2" opacity={0.7}/>
      {/* Level % */}
      <text x={cx} y={h/2+4} textAnchor="middle" fontSize={12} fontWeight="800"
        fill={color} fontFamily="monospace">{level}%</text>
      {/* Top dome */}
      <ellipse cx={cx} cy={8} rx={(w-16)/2} ry={5}
        fill="white" stroke={color} strokeWidth={1.5}/>
      {/* Bottom outlet */}
      <rect x={cx-4} y={h-17} width={8} height={10} rx={2} fill={color} opacity={0.7}/>
      {/* Label */}
      <text x={cx} y={h-2} textAnchor="middle" fontSize={9} fontWeight="700" fill={color}>{label}</text>
    </svg>
  )
}

// Distillation column SVG
function ColumnSVG({ label="HP", pres=5.8, temp=-170, w=38, h=120, color="#2563eb" }) {
  const cx = w/2
  return (
    <svg viewBox={`0 0 ${w} ${h}`} style={{width:w,height:h,display:"block"}}>
      {/* Column body */}
      <rect x={6} y={4} width={w-12} height={h-20} rx={3}
        fill="white" stroke={color} strokeWidth={1.5}/>
      {/* Trays (5 lines) */}
      {[0.2,0.35,0.5,0.65,0.8].map((f,i)=>(
        <line key={i} x1={7} y1={4+(h-24)*f} x2={w-7} y2={4+(h-24)*f}
          stroke={color} strokeWidth={0.7} opacity={0.4}/>
      ))}
      {/* Cold glow */}
      <rect x={7} y={5} width={w-14} height={(h-26)*0.4}
        fill="#dbeafe" opacity={0.3} rx={2}/>
      {/* Top inlet pipe */}
      <rect x={cx-2} y={0} width={4} height={6} fill={color} rx={1}/>
      {/* Bottom outlet */}
      <rect x={cx-2} y={h-18} width={4} height={8} fill={color} rx={1}/>
      {/* Label */}
      <text x={cx} y={h/2+2} textAnchor="middle" fontSize={8} fontWeight="800"
        fill={color}>{label}</text>
      <text x={cx} y={h/2+11} textAnchor="middle" fontSize={6} fill="#64748b"
        fontFamily="monospace">{pres}b</text>
      <text x={cx} y={h-6} textAnchor="middle" fontSize={7} fill="#0ea5e9"
        fontFamily="monospace">{temp}°</text>
    </svg>
  )
}

function VanHanhTramKhiView() {
  const [selOut, setSelOut] = useState(null)
  const [hovId,  setHovId]  = useState(null)

  const HPipe = ({color="#22c55e",active=true,width=28,flow=null,unit=""}) => (
    <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:1,flexShrink:0}}>
      <div style={{width,height:3,background:active?color:"#e2e8f0",borderRadius:2,
        opacity:active?1:0.5,boxShadow:active?`0 0 4px ${color}66`:"none",transition:"all .2s"}}/>
      {flow!=null&&<span style={{fontSize:7,color:active?color:"#94a3b8",fontWeight:600,whiteSpace:"nowrap"}}>
        {flow>0?`+${flow}`:flow} {unit}</span>}
    </div>
  )
  const Arrow = ({color="#22c55e",active=true,dir="right"}) => (
    <span style={{fontSize:10,color:active?color:"#e2e8f0",flexShrink:0,lineHeight:1,
      filter:active?`drop-shadow(0 0 2px ${color}88)`:"none"}}>
      {dir==="right"?"▶":"◀"}</span>
  )
  const ColHeader = ({title,count=null,extra=null}) => (
    <div style={{display:"flex",alignItems:"center",justifyContent:"space-between",marginBottom:12}}>
      <span style={{fontSize:11,fontWeight:700,color:"#64748b",letterSpacing:1,textTransform:"uppercase"}}>
        {title}{count!=null&&<span style={{fontWeight:400,fontSize:10,color:"#94a3b8"}}> ({count})</span>}
      </span>
      {extra||<div/>}
    </div>
  )

  // OutputCard canonical pattern
  const OutputCard = ({item}) => {
    const isSel = selOut?.id===item.id
    const isHov = hovId===item.id
    return (
      <div onClick={()=>setSelOut(isSel?null:item)}
        onMouseEnter={()=>setHovId(item.id)} onMouseLeave={()=>setHovId(null)}
        style={{background:"white",border:`2px solid ${isSel?"#2563eb":item.active?"#e2e8f0":"#f1f5f9"}`,
          borderRadius:8,padding:"10px 12px",cursor:"pointer",marginBottom:8,
          boxShadow:isSel?"0 0 0 3px rgba(37,99,235,.15)":isHov?"0 2px 8px rgba(0,0,0,0.08)":"none",
          transition:"all .15s",opacity:item.active?1:0.55}}>
        <div style={{display:"flex",alignItems:"center",gap:6,marginBottom:6}}>
          <div style={{width:28,height:28,borderRadius:5,flexShrink:0,
            background:item.color+"22",display:"flex",alignItems:"center",justifyContent:"center",
            fontSize:14,fontWeight:900,color:item.color,fontFamily:"serif"}}>
            {item.id.startsWith("O2")?"O₂":"N₂"}
          </div>
          <div style={{flex:1}}>
            <div style={{fontSize:11,fontWeight:700,color:"#374151"}}>{item.label}</div>
            <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8"}}>{item.id}</div>
          </div>
          <span style={{fontSize:9,fontWeight:700,padding:"1px 6px",borderRadius:8,
            background:item.active?"#dcfce7":"#fee2e2",
            color:item.active?"#16a34a":"#dc2626"}}>
            {item.active?"Đang cấp":"Dừng"}</span>
        </div>
        {/* Flow row */}
        <div style={{display:"flex",alignItems:"center",gap:4,marginBottom:4}}>
          <Arrow color={item.color} active={item.active} dir="left"/>
          <div style={{width:6,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <svg viewBox="0 0 28 18" style={{width:28,height:18,flexShrink:0}}>
            <rect x={1} y={2} width={12} height={14} rx={2} fill="white" stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <circle cx={7} cy={9} r={3} fill={item.active?item.color:"#e2e8f0"} opacity={0.25}/>
            <circle cx={7} cy={9} r={1.5} fill={item.active?item.color:"#e2e8f0"}/>
            <line x1={13} y1={9} x2={18} y2={9} stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
            <rect x={18} y={2} width={9} height={14} rx={2} fill="white" stroke={item.active?item.color:"#e2e8f0"} strokeWidth={1.5}/>
          </svg>
          <div style={{width:8,height:3,background:item.active?item.color:"#e2e8f0",borderRadius:2}}/>
          <div style={{flex:1,textAlign:"right"}}>
            <span style={{fontSize:14,fontWeight:800,color:item.active?item.color:"#94a3b8",fontFamily:"monospace"}}>{item.flow}</span>
            <span style={{fontSize:9,color:"#94a3b8",marginLeft:2}}>{item.unit}</span>
          </div>
        </div>
        <div style={{display:"flex",justifyContent:"space-between",fontSize:9,color:"#64748b"}}>
          <span>Tinh khiết: <span style={{fontWeight:700,color:item.color,fontFamily:"monospace"}}>{item.purity}%</span></span>
          <span>Áp: <span style={{fontWeight:700,fontFamily:"monospace"}}>{item.pres} bar</span></span>
        </div>
      </div>
    )
  }

  // Detail panel
  const DetailPanel = () => {
    if (!selOut) return (
      <div style={{height:"100%",display:"flex",flexDirection:"column",
        alignItems:"center",justifyContent:"center",
        color:"#94a3b8",padding:20,textAlign:"center",gap:8}}>
        <span style={{fontSize:32}}>🔬</span>
        <span style={{fontWeight:600,color:"#64748b",fontSize:12}}>Chọn đầu ra</span>
        <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>Nhấp vào đường cấp khí để xem thông số</span>
      </div>
    )
    const trend = Array.from({length:18},(_,i)=>
      30+Math.abs(Math.sin(i/3))*50+(Math.random()-.5)*8
    )
    return (
      <div>
        <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
          display:"flex",alignItems:"center",justifyContent:"space-between"}}>
          <div>
            <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{selOut.id} · </span>
            <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{selOut.label}</span>
          </div>
          <button style={{background:"none",border:"none",cursor:"pointer",color:"#94a3b8",fontSize:16}}>⋯</button>
        </div>
        <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
          {["Thông tin","Lịch sử"].map((t,i)=>(
            <button key={t} style={{padding:"8px 12px",border:"none",cursor:"pointer",fontSize:11,
              fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
              borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",background:"none"}}>{t}</button>
          ))}
        </div>
        <div style={{padding:"14px",background:"white",borderBottom:"1px solid #f1f5f9",textAlign:"center"}}>
          <div style={{fontSize:28,fontWeight:900,fontFamily:"monospace",color:selOut.color,lineHeight:1}}>{selOut.flow}</div>
          <div style={{fontSize:10,color:"#94a3b8",marginTop:4}}>{selOut.unit}</div>
        </div>
        {[
          ["Lưu lượng",    `${selOut.flow} ${selOut.unit}`],
          ["Độ tinh khiết",`${selOut.purity}%`],
          ["Áp suất",      `${selOut.pres} bar`],
          ["Trạng thái",   selOut.active?"Đang cấp":"Dừng"],
        ].map(([k,v])=>(
          <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
            <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
            <span style={{fontSize:11,fontWeight:600,color:"#0f172a"}}>{v}</span>
          </div>
        ))}
        <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>24H QUA</div>
        <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
          <div style={{display:"flex",alignItems:"flex-end",gap:1,height:44}}>
            {trend.map((v,i)=>(
              <div key={i} style={{flex:1,height:`${v}%`,background:selOut.color,borderRadius:"1px 1px 0 0",opacity:0.8}}/>
            ))}
          </div>
          <div style={{display:"flex",justifyContent:"space-between",marginTop:2}}>
            <span style={{fontSize:7,color:"#94a3b8"}}>-24h</span>
            <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div style={{flex:1,display:"flex",overflow:"hidden"}}>
      <div style={{flex:1,overflow:"auto",padding:"14px 16px"}}>
        {/* KPI strip */}
        <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
          {[
            {label:"O₂ sản xuất",    value:"1 240 Nm³/h", icon:"🔴", color:"#ef4444"},
            {label:"N₂ sản xuất",    value:"1 180 Nm³/h", icon:"🔵", color:"#2563eb"},
            {label:"Tinh khiết O₂",  value:"99.6%",       icon:"🔬", color:"#ef4444"},
            {label:"Tinh khiết N₂",  value:"99.999%",     icon:"🔬", color:"#2563eb"},
            {label:"Công suất",      value:"1 840 kW",    icon:"⚡", color:"#f59e0b"},
            {label:"Nhiệt độ CB",    value:"-175°C",      icon:"❄", color:"#0ea5e9"},
          ].map(k=>(
            <div key={k.label} style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"8px 12px",display:"flex",alignItems:"center",gap:8,
              flex:1,minWidth:90,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <span style={{fontSize:18}}>{k.icon}</span>
              <div>
                <div style={{fontSize:13,fontWeight:800,color:k.color,lineHeight:1}}>{k.value}</div>
                <div style={{fontSize:9,color:"#94a3b8",marginTop:1}}>{k.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* 3 columns */}
        <div style={{display:"flex",gap:0,minWidth:600}}>

          {/* COL 1: ASU process + tanks */}
          <div style={{width:220,borderRight:"1px solid #e2e8f0",paddingRight:12,flexShrink:0}}>
            <ColHeader title="Sơ đồ ASU"/>
            {/* Process flow inline */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"12px 10px",marginBottom:8,boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              {/* Air in → columns → products */}
              <div style={{display:"flex",alignItems:"center",gap:4,marginBottom:10}}>
                <div style={{fontSize:9,color:"#64748b",fontWeight:700,width:38}}>Khí vào</div>
                <HPipe color="#64748b" active={true} width={12}/>
                <Arrow color="#64748b" active={true} dir="right"/>
                <div style={{background:"#f8fafc",border:"1px solid #e2e8f0",borderRadius:5,
                  padding:"2px 6px",fontSize:9,fontWeight:700,color:"#374151",whiteSpace:"nowrap"}}>
                  MN + Sấy
                </div>
                <HPipe color="#2563eb" active={true} width={12}/>
                <Arrow color="#2563eb" active={true} dir="right"/>
                <div style={{fontSize:8,color:"#2563eb",fontWeight:700}}>CB</div>
              </div>
              {/* Columns side by side */}
              <div style={{display:"flex",gap:8,justifyContent:"center",marginBottom:10}}>
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
                  <ColumnSVG label="HP" pres={5.8} temp={-170} w={38} h={100} color="#2563eb"/>
                  <div style={{fontSize:8,color:"#2563eb",fontWeight:700}}>Cột HP</div>
                </div>
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"flex-end",gap:2}}>
                  <HPipe color="#ef4444" active={true} width={20}/>
                  <Arrow color="#ef4444" active={true} dir="right"/>
                  <div style={{height:20}}/>
                  <Arrow color="#2563eb" active={true} dir="left"/>
                  <HPipe color="#2563eb" active={true} width={20}/>
                </div>
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
                  <ColumnSVG label="LP" pres={1.35} temp={-175} w={38} h={100} color="#ef4444"/>
                  <div style={{fontSize:8,color:"#ef4444",fontWeight:700}}>Cột LP</div>
                </div>
              </div>
              {/* Product labels */}
              <div style={{display:"flex",justifyContent:"space-between",
                borderTop:"1px solid #f1f5f9",paddingTop:6}}>
                <div style={{textAlign:"center"}}>
                  <div style={{fontSize:8,color:"#2563eb",fontWeight:700}}>N₂ ↑</div>
                  <div style={{fontSize:8,fontFamily:"monospace",color:"#2563eb"}}>99.999%</div>
                </div>
                <div style={{textAlign:"center"}}>
                  <div style={{fontSize:8,color:"#ef4444",fontWeight:700}}>O₂ ↓</div>
                  <div style={{fontSize:8,fontFamily:"monospace",color:"#ef4444"}}>99.6%</div>
                </div>
              </div>
            </div>
            {/* Storage tanks */}
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              <div style={{fontSize:9,fontWeight:700,color:"#64748b",letterSpacing:1,
                textTransform:"uppercase",marginBottom:8}}>Bồn chứa</div>
              <div style={{display:"flex",gap:12,justifyContent:"center"}}>
                <TankSVG level={68} label="LOX" color="#ef4444" w={56} h={90}/>
                <TankSVG level={45} label="LIN" color="#2563eb" w={56} h={90}/>
              </div>
              <div style={{display:"flex",justifyContent:"space-around",marginTop:6}}>
                {[
                  {k:"LOX",v:"68%",c:"#ef4444"},{k:"LIN",v:"45%",c:"#2563eb"}
                ].map(r=>(
                  <div key={r.k} style={{textAlign:"center"}}>
                    <div style={{fontSize:13,fontWeight:900,color:r.c,fontFamily:"monospace"}}>{r.v}</div>
                    <div style={{fontSize:8,color:"#94a3b8"}}>{r.k} — 40/20 kL</div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* COL 2: Production params */}
          <div style={{flex:1,borderRight:"1px solid #e2e8f0",padding:"0 12px",minWidth:180}}>
            <ColHeader title="Thông số sản xuất"/>
            <div style={{background:"white",border:"1px solid #e2e8f0",borderRadius:8,
              padding:"10px 12px",boxShadow:"0 1px 3px rgba(0,0,0,0.04)"}}>
              {Object.values(ASU_PARAMS).map(p=>{
                const over = p.set && Math.abs(p.val - p.set) / (p.set||1) > 0.05
                return (
                  <div key={p.label} style={{
                    display:"flex",justifyContent:"space-between",alignItems:"center",
                    padding:"6px 0",borderBottom:"1px solid #f8fafc"
                  }}>
                    <span style={{fontSize:9,color:"#64748b",flex:1}}>{p.label}</span>
                    <div style={{display:"flex",alignItems:"baseline",gap:4}}>
                      <span style={{
                        fontSize:13,fontWeight:800,fontFamily:"monospace",
                        color:over?"#ef4444":p.color,
                        background:over?"#fee2e2":"transparent",
                        padding:over?"1px 4px":"0",borderRadius:3
                      }}>{p.val}</span>
                      <span style={{fontSize:8,color:"#94a3b8"}}>{p.unit}</span>
                      {p.set&&<span style={{fontSize:7,color:"#94a3b8"}}>/{p.set}</span>}
                    </div>
                  </div>
                )
              })}
            </div>
          </div>

          {/* COL 3: Outputs */}
          <div style={{flex:1,paddingLeft:12,minWidth:170}}>
            <div style={{display:"flex",alignItems:"center",marginBottom:12}}>
              <Arrow color="#ef4444" active={true} dir="left"/>
              <HPipe color="#ef4444" active={true} width={12}/>
              <div style={{flex:1}}>
                <ColHeader title="Cấp khí" count={ASU_OUTPUTS.length}/>
              </div>
            </div>
            {ASU_OUTPUTS.map(o=><OutputCard key={o.id} item={o}/>)}
          </div>

        </div>
      </div>

      {/* Detail panel */}
      <div style={{width:268,background:"white",borderLeft:"1px solid #e2e8f0",flexShrink:0,overflowY:"auto"}}>
        <DetailPanel/>
      </div>
    </div>
  )
}

// ─── PXKhiPanel ───────────────────────────────────────────

function PXKhiPanel() {
  const [pxkhiSubTab,  setPxkhiSubTab]  = useState("Tháp Phân Lưu")
  const [search,       setSearch]       = useState("")
  const [filterType,   setFilterType]   = useState("Tous")
  const [alarmOnly,    setAlarmOnly]    = useState(false)
  const [viewMode,     setViewMode]     = useState("table")
  const [selectedItem, setSelectedItem] = useState(null)

  const types   = ["Tous", ...Array.from(new Set(PXKHI_DATA.map(d=>d.type)))]
  const filtered = PXKHI_DATA.filter(d => {
    if (alarmOnly && !d.alarm) return false
    if (filterType !== "Tous" && d.type !== filterType) return false
    if (search && !d.name.toLowerCase().includes(search.toLowerCase()) &&
                  !d.id.toLowerCase().includes(search.toLowerCase())) return false
    return true
  })

  return (
    <div style={{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",background:"#f8fafc"}}>
      {/* Tab bar */}
      <div style={{background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"0 16px",display:"flex",alignItems:"center",gap:4,flexShrink:0}}>
        {["Thiết bị","Tháp Phân Lưu","Vận Hành Trạm Khí"].map(t=>(
          <button key={t} onClick={()=>setPxkhiSubTab(t)} style={{
            padding:"10px 16px",border:"none",cursor:"pointer",fontSize:12,fontWeight:500,
            background:"transparent",
            color:pxkhiSubTab===t?"#1e3a5f":"#64748b",
            borderBottom:pxkhiSubTab===t?"2px solid #1e3a5f":"2px solid transparent",
            transition:"all .15s",whiteSpace:"nowrap"
          }}>{t}</button>
        ))}
      </div>

      {pxkhiSubTab==="Tháp Phân Lưu" ? <ThapPhanLuuView/> : pxkhiSubTab==="Vận Hành Trạm Khí" ? <VanHanhTramKhiView/> : (
      <>
      {/* Toolbar */}
      <div style={{background:"white",borderBottom:"1px solid #e2e8f0",
        padding:"10px 16px",display:"flex",alignItems:"center",gap:10,flexShrink:0,flexWrap:"wrap"}}>
        <div style={{display:"flex",alignItems:"center",gap:6,background:"#f8fafc",
          border:"1px solid #e2e8f0",borderRadius:6,padding:"5px 10px",minWidth:180}}>
          <span style={{color:"#94a3b8",fontSize:13}}>🔍</span>
          <input value={search} onChange={e=>setSearch(e.target.value)}
            placeholder="Tìm kiếm..."
            style={{border:"none",outline:"none",background:"transparent",fontSize:12,color:"#374151",width:140}}/>
        </div>
        <div style={{display:"flex",gap:4,flexWrap:"wrap"}}>
          {types.map(t=>(
            <button key={t} onClick={()=>setFilterType(t)} style={{
              padding:"4px 10px",border:"none",borderRadius:12,cursor:"pointer",fontSize:11,fontWeight:500,
              background:filterType===t?"#2563eb":"#f1f5f9",
              color:filterType===t?"white":"#64748b",transition:"all .15s"
            }}>{t}</button>
          ))}
        </div>
        <button onClick={()=>setAlarmOnly(p=>!p)} style={{
          padding:"4px 10px",border:`1px solid ${alarmOnly?"#ef4444":"#e2e8f0"}`,
          borderRadius:12,cursor:"pointer",fontSize:11,fontWeight:500,
          background:alarmOnly?"#fee2e2":"white",
          color:alarmOnly?"#ef4444":"#64748b",transition:"all .15s"
        }}>⚠ Chỉ cảnh báo</button>
        <div style={{flex:1}}/>
        <span style={{fontSize:11,color:"#94a3b8"}}>{filtered.length} thiết bị</span>
        <div style={{display:"flex",gap:2}}>
          {["table","grid"].map(m=>(
            <button key={m} onClick={()=>setViewMode(m)} style={{
              padding:"5px 8px",border:"none",borderRadius:5,cursor:"pointer",
              background:viewMode===m?"#2563eb":"#f1f5f9",
              color:viewMode===m?"white":"#64748b",fontSize:13,transition:"all .15s"
            }}>{m==="table"?"≡":"⊞"}</button>
          ))}
        </div>
      </div>

      {/* Content + detail */}
      <div style={{flex:1,display:"flex",overflow:"hidden"}}>
        <div style={{flex:1,overflow:"auto"}}>
          {viewMode==="table" ? (
            <table style={{width:"100%",borderCollapse:"collapse",fontSize:12}}>
              <thead>
                <tr style={{background:"#f8fafc",borderBottom:"2px solid #e2e8f0"}}>
                  {["ID","Tên thiết bị","Loại","SL","Ngày SD","Trạng thái","Cảnh báo"].map(h=>(
                    <th key={h} style={{padding:"8px 12px",textAlign:"left",fontWeight:600,
                      color:"#64748b",fontSize:11,whiteSpace:"nowrap"}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map(item=>{
                  const ss  = STATUS_STYLES[item.status]||STATUS_STYLES.ok
                  const sel = selectedItem?.id===item.id
                  return (
                    <tr key={item.id} onClick={()=>setSelectedItem(p=>p?.id===item.id?null:item)}
                      style={{background:sel?"#eff6ff":item.alarm?"#fff7f7":"white",
                        borderBottom:"1px solid #f1f5f9",cursor:"pointer",transition:"background .1s"}}>
                      <td style={{padding:"8px 12px",fontFamily:"monospace",color:"#64748b",fontSize:11}}>{item.id}</td>
                      <td style={{padding:"8px 12px",fontWeight:600,color:"#0f172a",maxWidth:300}}>{item.name}</td>
                      <td style={{padding:"8px 12px",color:"#64748b",whiteSpace:"nowrap"}}>{item.type}</td>
                      <td style={{padding:"8px 12px",textAlign:"center",fontWeight:700,color:"#374151"}}>{item.qty}</td>
                      <td style={{padding:"8px 12px",color:"#64748b",whiteSpace:"nowrap",fontSize:11}}>{item.since}</td>
                      <td style={{padding:"8px 12px"}}>
                        <span style={{background:ss.bg,color:ss.color,padding:"2px 8px",borderRadius:8,fontSize:10,fontWeight:600}}>{ss.label}</span>
                      </td>
                      <td style={{padding:"8px 12px",textAlign:"center"}}>
                        {item.alarm
                          ? <span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",
                              display:"inline-flex",alignItems:"center",justifyContent:"center",
                              fontSize:9,color:"white",fontWeight:900}}>!</span>
                          : <span style={{color:"#22c55e",fontSize:14}}>✓</span>}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          ) : (
            <div style={{display:"grid",gridTemplateColumns:"repeat(auto-fill,minmax(180px,1fr))",gap:10,padding:14}}>
              {filtered.map(item=>{
                const ss  = STATUS_STYLES[item.status]||STATUS_STYLES.ok
                const sel = selectedItem?.id===item.id
                return (
                  <div key={item.id} onClick={()=>setSelectedItem(p=>p?.id===item.id?null:item)}
                    style={{background:"white",borderRadius:8,padding:12,cursor:"pointer",
                      border:`2px solid ${sel?"#2563eb":item.alarm?"#fca5a5":"#e2e8f0"}`,
                      boxShadow:sel?"0 0 0 3px rgba(37,99,235,.12)":"0 1px 3px rgba(0,0,0,0.04)",
                      transition:"all .15s"}}>
                    <div style={{fontSize:9,fontFamily:"monospace",color:"#94a3b8",marginBottom:4}}>{item.id}</div>
                    <div style={{fontSize:11,fontWeight:700,color:"#374151",marginBottom:8,lineHeight:1.3}}>{item.name}</div>
                    <div style={{fontSize:20,fontWeight:800,color:"#374151",lineHeight:1}}>
                      {item.qty} <span style={{fontSize:11,color:"#94a3b8",fontWeight:400}}>chiếc</span>
                    </div>
                    <div style={{fontSize:9,color:"#94a3b8",marginBottom:8}}>Sử dụng từ {item.since}</div>
                    <div style={{display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                      <span style={{background:ss.bg,color:ss.color,padding:"2px 7px",borderRadius:8,fontSize:9,fontWeight:600}}>{ss.label}</span>
                      {item.alarm&&<span style={{width:16,height:16,borderRadius:"50%",background:"#ef4444",
                        display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:8,color:"white",fontWeight:900}}>!</span>}
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
        {/* Detail panel */}
        <div style={{width:268,background:"white",borderLeft:"1px solid #e2e8f0",flexShrink:0,overflowY:"auto"}}>
          {!selectedItem ? (
            <div style={{height:"100%",display:"flex",flexDirection:"column",alignItems:"center",justifyContent:"center",
              color:"#94a3b8",fontSize:12,padding:20,textAlign:"center",gap:8}}>
              <span style={{fontSize:32}}>⚙</span>
              <span style={{fontWeight:600,color:"#64748b"}}>Chưa chọn đối tượng</span>
              <span style={{fontSize:11,color:"#cbd5e1",lineHeight:1.5}}>Nhấp vào một thiết bị</span>
            </div>
          ) : (()=>{
            const item = selectedItem
            const ss   = STATUS_STYLES[item.status]||STATUS_STYLES.ok
            const trend = Array.from({length:20},(_,i)=>20+Math.abs(Math.sin(i/3))*60+(Math.random()-.5)*10)
            return (
              <div>
                <div style={{padding:"10px 14px",background:"#f8fafc",borderBottom:"1px solid #e2e8f0",
                  display:"flex",alignItems:"center",justifyContent:"space-between"}}>
                  <div>
                    <span style={{fontSize:9,color:"#94a3b8",fontFamily:"monospace"}}>{item.id} · </span>
                    <span style={{fontSize:12,fontWeight:700,color:"#0f172a"}}>{item.name}</span>
                  </div>
                  {item.alarm&&<span style={{width:18,height:18,borderRadius:"50%",background:"#ef4444",
                    display:"inline-flex",alignItems:"center",justifyContent:"center",fontSize:9,color:"white",fontWeight:900}}>!</span>}
                </div>
                <div style={{display:"flex",borderBottom:"1px solid #f1f5f9"}}>
                  {["Thông tin","Lịch sử","Cảnh báo"].map((t,i)=>(
                    <button key={t} style={{padding:"8px 10px",border:"none",cursor:"pointer",fontSize:11,
                      fontWeight:i===0?700:400,color:i===0?"#2563eb":"#94a3b8",
                      borderBottom:i===0?"2px solid #2563eb":"2px solid transparent",background:"none"}}>{t}</button>
                  ))}
                </div>
                <div style={{padding:"14px",display:"flex",alignItems:"center",gap:10,background:"white",borderBottom:"1px solid #f1f5f9"}}>
                  <div style={{flex:1}}>
                    <div style={{fontSize:24,fontWeight:800,color:"#374151",lineHeight:1}}>
                      {item.qty} <span style={{fontSize:13,fontWeight:400,color:"#94a3b8"}}>chiếc</span>
                    </div>
                    <div style={{fontSize:11,color:"#94a3b8",marginTop:2}}>Sử dụng từ {item.since}</div>
                  </div>
                  <span style={{background:ss.bg,color:ss.color,padding:"3px 10px",borderRadius:10,fontSize:10,fontWeight:600}}>{ss.label}</span>
                </div>
                {[["Mã máy",item.id],["Loại",item.type],["Số lượng",`${item.qty} chiếc`],["Ngày SD",item.since],["Trạng thái",ss.label],["Cảnh báo",item.alarm?"Có":"Không"]].map(([k,v])=>(
                  <div key={k} style={{display:"flex",justifyContent:"space-between",padding:"7px 14px",borderBottom:"1px solid #f8fafc"}}>
                    <span style={{fontSize:11,color:"#94a3b8"}}>{k}</span>
                    <span style={{fontSize:11,fontWeight:600,color:k==="Cảnh báo"&&item.alarm?"#ef4444":"#0f172a"}}>{v}</span>
                  </div>
                ))}
                <div style={{padding:"8px 14px 2px",fontSize:9,fontWeight:700,color:"#94a3b8",letterSpacing:1,background:"#f8fafc",marginTop:4}}>GIỜ VỪA QUA</div>
                <div style={{padding:"6px 14px 14px",background:"#f8fafc"}}>
                  <div style={{display:"flex",alignItems:"flex-end",gap:1,height:52}}>
                    {trend.map((v,i)=>(
                      <div key={i} style={{flex:1,height:`${v}%`,background:item.alarm?"#ef4444":"#22c55e",
                        borderRadius:"1px 1px 0 0",opacity:0.8}}/>
                    ))}
                  </div>
                  <div style={{display:"flex",justifyContent:"space-between",marginTop:3}}>
                    <span style={{fontSize:7,color:"#94a3b8"}}>-1h</span>
                    <span style={{fontSize:7,color:"#94a3b8"}}>hiện tại</span>
                  </div>
                </div>
              </div>
            )
          })()}
        </div>
      </div>
      </>
      )}
    </div>
  )
}

export default PXKhiPanel
